import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import {Alert, Avatar, Box, Button, Card, Divider, Link, Stack, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';
import DownloadIcon from '@mui/icons-material/Download';
import DatasetLinkedIcon from '@mui/icons-material/DatasetLinked';

const Downloads = (): JSX.Element => {

    document.title = 'OCPF - Data Downloads';
    
    // since 2002
    const downloadYears = Array.from(new Array(new Date().getFullYear()-2001), (val, index) => new Date().getFullYear() - index);

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
            variant="h5"
            align={'left'}
            data-aos={'fade-up'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            Data Downloads <Typography component="span" variant="caption" color="text.secondary">Updated nightly at 3:30 AM</Typography>
        </Typography>
        <Divider/>
        <Grid container marginTop={3}>
            <Grid size={12}>
                <Alert icon={false} severity="info">
                    <Stack direction={"row"} spacing={1}>
                        <InfoIcon color="primary" fontSize='small' />
                        <Typography variant='subtitle2'>The primary data format is tab-delimited text for broader compatibility.</Typography>
                    </Stack>
                    <Stack direction={"row"} spacing={1} marginTop={1}>
                        <InfoIcon color="primary" fontSize='small' />
                        <Typography variant='subtitle2'>Readme files are included with the data to provide some guidance.</Typography>
                    </Stack>
                    <Stack direction={"row"} spacing={1} marginTop={1}>
                        <InfoIcon color="primary" fontSize='small' />
                        <Typography variant='subtitle2'>Please contact ocpf@mass.gov for any related questions.</Typography>
                    </Stack>
                </Alert>
            </Grid> 
            <Grid size={12} marginTop={1}>
                <Box
                    padding={1}
                    width={1}
                    marginTop={2}
                    component={Card}
                >
                    <Typography
                        variant="subtitle2"
                        align={'left'}
                        fontWeight={600}
                        gutterBottom
                    >
                        Click to download report data by year
                    </Typography>
                    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                    {
                        downloadYears.map((year) => (
                        <Box key={year} padding={1}>
                            <Button
                                variant={'outlined'}
                                color={'primary'}
                                size={'small'}
                                href={`https://ocpf2.blob.core.windows.net/downloads/data2/ocpf-${year}-reports.zip`}
                                rel={'noreferrer noopener'}
                            >
                                {year}
                            </Button>
                        </Box>
                        ))
                    }
            </Stack>
                </Box>
            </Grid>
            <Grid size={12} marginTop={3}>
                <Box
                    padding={1}
                    width={1}
                    marginTop={2}
                    component={Card}
                >
                    <Typography
                        variant="subtitle2"
                        align={'left'}
                        fontWeight={600}
                        gutterBottom
                    >
                        Other Filer Datasets
                    </Typography>
                    <TableContainer>
                        <Table aria-label="list of OCPF datasets">
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <Box
                                        component={Avatar}
                                        width={30}
                                        height={30}
                                        marginBottom={2}
                                        bgcolor={'primary.main'}
                                        variant={'rounded'}
                                        borderRadius={2}
                                        >
                                          <DatasetLinkedIcon fontSize='small' />
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="subtitle1" fontWeight={550}>
                                            All Independent Expenditure Data
                                        </Typography>
                                    </TableCell>
                                    <TableCell width={'15%'}>
                                        <Stack direction="column" spacing={0.5}>
                                            <Button 
                                                component={Link} 
                                                href={'https://ocpf2.blob.core.windows.net/downloads/data2/independent-spending-report-data.zip'} 
                                                target='_blank' startIcon={<DownloadIcon />} 
                                                sx={{justifyContent: 'flex-start'}}
                                            >
                                                txt
                                            </Button>
                                        </Stack>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant={'subtitle2'}>
                                            Download a zipped file containing independent spending reports and their items. This file does not include data from Independent Expenditure PAC reports. These records can be found in the “Filer Report Data” download listed above. This zip file also contains a readme file.
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Box
                                        component={Avatar}
                                        width={30}
                                        height={30}
                                        marginBottom={2}
                                        bgcolor={'primary.main'}
                                        variant={'rounded'}
                                        borderRadius={2}
                                        >
                                          <DatasetLinkedIcon fontSize='small' />
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="subtitle1" fontWeight={550}>
                                            Filer Database
                                        </Typography>
                                    </TableCell>
                                    <TableCell width={'15%'} sx={{textAlign: 'left!important'}}>
                                        <Stack direction="column" spacing={0.5}>
                                            <Button 
                                                component={Link} 
                                                href={'https://ocpf2.blob.core.windows.net/downloads/data2/ocpf-filers.zip'} 
                                                target='_blank'
                                                startIcon={<DownloadIcon />} 
                                                sx={{justifyContent: 'flex-start'}}
                                            >
                                                txt
                                            </Button>
                                            <Button
                                                component={Link}
                                                href={'https://ocpf2.blob.core.windows.net/downloads/data2/ocpf-filers-excel.zip'}
                                                target='_blank' 
                                                startIcon={<DownloadIcon />} 
                                                sx={{justifyContent: 'flex-start'}}
                                            >
                                                excel
                                            </Button>
                                        </Stack>
                                    </TableCell>
                                    <TableCell>
                                        <Typography component={'div'} variant={'subtitle2'}>
                                            <p>Download a zip file containing all OCPF-registered filers. The zip file contains the following text files:</p>
                                            <ul>
                                                <li>All filers</li>
                                                <li>Only Candidates</li>
                                                <li>Only Political Action Committees (including independent expenditure PACs)</li>
                                                <li>Only Local party committees</li>
                                            </ul>
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Box
                                        component={Avatar}
                                        width={30}
                                        height={30}
                                        marginBottom={2}
                                        bgcolor={'primary.main'}
                                        variant={'rounded'}
                                        borderRadius={2}
                                        >
                                          <DatasetLinkedIcon fontSize='small' />
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="subtitle1" fontWeight={550}>
                                            Candidate Districts
                                        </Typography>
                                    </TableCell>
                                    <TableCell width={'15%'}>
                                        <Stack direction="column" spacing={0.5}>
                                            <Button 
                                                component={Link}
                                                href={'https://ocpf2.blob.core.windows.net/downloads/data2/district_code_list.zip'}
                                                target='_blank' 
                                                startIcon={<DownloadIcon />} 
                                                sx={{justifyContent: 'flex-start'}}>
                                                txt/excel
                                            </Button>
                                        </Stack>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant={'subtitle2'}>
                                            Download a listing of all registered candidate office districts including legislative, county and municipal districts. Click to download a Microsoft Excel (.xlsx) and a tab-delimited text (.txt) file (zipped).
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Box
                                        component={Avatar}
                                        width={30}
                                        height={30}
                                        marginBottom={2}
                                        bgcolor={'primary.main'}
                                        variant={'rounded'}
                                        borderRadius={2}
                                        >
                                          <DatasetLinkedIcon fontSize='small' />
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="subtitle1" fontWeight={550}>
                                            Account Type Listings
                                        </Typography>
                                    </TableCell>
                                    <TableCell width={'15%'}>
                                        <Stack direction="column" spacing={0.5}>
                                            <Button
                                                component={Link}
                                                href={'https://ocpf2.blob.core.windows.net/downloads/data2/account_types.zip'}
                                                target='_blank'  
                                                startIcon={<DownloadIcon />} 
                                                sx={{justifyContent: 'flex-start'}}
                                            >
                                                txt/excel
                                            </Button>
                                        </Stack>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant={'subtitle2'}>
                                            Download a listing of all of the category types for OCPF Filers. Click to download a Microsoft Excel (.xlsx) and a tab-delimited text (.txt) file (zipped).
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default Downloads;